import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="border-y border-foreground-950/10 bg-background-100 paper-grain">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按方向查找你关心的爆料"
          desc="我们按线索的类型归档，方便你快速定位。每个分类下的内容都由同一支核实小组处理，标注规则一致。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.key}
              to={`/scoops?cat=${cat.key}`}
              className="group flex items-start gap-4 rounded-lg border border-foreground-950/10 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
                <i className={`${cat.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950">{cat.label}</span>
                  <span className="shrink-0 text-xs text-foreground-500">{cat.count} 条</span>
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}